import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import swal from "sweetalert";

import {
  Create_Warehouse_List,
  Delete_WareHouse,
} from "../../ApiEndPoint/Api";

import { Trash2 } from "react-feather";
import { FaPlus, FaStoreAlt, FaPencilAlt } from "react-icons/fa";
import { _Get } from "../../ApiEndPoint/ApiCalling";
import axiosConfig from "../../AxiosConfig"
export default function Warehouse() {
  const gridRef = useRef();
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch Data
  const fetchData = async () => {
    try {
      setLoading(true);

      const userInfo = JSON.parse(localStorage.getItem("userData"));
      const db = userInfo?.database;
      const id = userInfo?._id;
      const res = await axiosConfig.get(`/warehouse/view-warehouse/${db}`);

      console.log("res", res);

      let value = res?.data?.Warehouse;
      let List = [];

      // ✅ Role wise filter
      if (
        userInfo?.rolename?.roleName === "MASTER" ||
        userInfo?.rolename?.roleName === "SuperAdmin"
      ) {
        List = value || [];
      } else {
        List = value?.filter((ele) => ele?.created_by?._id === id);
      }

      setRowData(List || []);

    } catch (err) {
      console.log(err);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔥 Delete
  const handleDelete = (id) => {

    swal("Warning", "Delete this warehouse?", {
      buttons: ["Cancel", "Delete"],
    })

      .then(async (value) => {

        if (value) {

          try {

            const res = await axiosConfig.delete(
              `/warehouse/delete-warehouse/${id}`
            );

            console.log("DELETE RESPONSE", res);

            swal("Deleted Successfully");

            fetchData();

          } catch (err) {

            console.log("DELETE ERROR", err?.response);

            swal("Error deleting");

          }

        }

      });

  };
  const handleMultiDelete = () => {

    if (selectedRows.length === 0) {
      swal("Please select warehouse");
      return;
    }

    swal("Warning", "Delete selected warehouses?", {
      buttons: ["Cancel", "Delete"],
    })

      .then(async (value) => {

        if (value) {

          try {

            for (let item of selectedRows) {

              await axiosConfig.delete(
                `/warehouse/delete-warehouse/${item._id}`
              );

            }

            swal("Deleted Successfully");

            fetchData();

          } catch (err) {

            console.log(err);

            swal("Error deleting");

          }

        }

      });

  };
  // 🔥 Columns
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Actions",
      width: 150,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "8px" }}>

          {/* View */}
          {/* <span
            style={{
              background: "#39cccc",
              padding: "5px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/production?view=warehouse-view-${params?.data?._id}`)
            }
          >
            <FaStoreAlt size={12} color="white" />
          </span> */}

          {/* Edit */}

          <span
            style={{
              background: "orange",
              padding: "5px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(
                `/production?view=edit-warehouse&id=${params?.data?._id}`
              )
            }
          >
            <FaPencilAlt size={12} color="white" />
          </span>

          {/* Delete */}
          <span
            style={{
              background: "red",
              padding: "5px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params?.data?._id)}
          >
            <Trash2 size={12} color="white" />
          </span>
        </div>
      ),
    },
    { headerName: "Status", field: "status", width: 100 },
    { headerName: "Warehouse ID", field: "id" },
    { headerName: "Warehouse Type", field: "warehouseType" },

    { headerName: "Warehouse Name", field: "warehouseName" },
    { headerName: "Mobile", field: "mobileNo" },
    { headerName: "Landline", field: "landlineNumber" },
    { headerName: "Address", field: "address", width: 250 },
    {
      headerName: "Created",
      valueGetter: (p) => p?.data?.createdAt?.split("T")[0],
    },
    {
      headerName: "Updated",
      valueGetter: (p) => p?.data?.updatedAt?.split("T")[0],
    },
  ];

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="erp-page-grid">

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Warehouse</h2>
        <Button style={{ marginLeft: "1200px" }}
          color="danger"
          onClick={handleMultiDelete}
        >
          Delete Selected
        </Button>
        <Button
          color="primary"
          onClick={() =>
            navigate(`/production?view=create-warehouse`)
          }
        >
          <FaPlus /> Create Warehouse
        </Button>
      </div>

      <div
        className="ag-theme-alpine"
        style={{ height: "500px", marginTop: "10px" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination
          rowSelection="multiple"
          onSelectionChanged={() => {

            const selected =
              gridRef.current.api.getSelectedRows();

            setSelectedRows(selected);

          }}
        />
      </div>
    </div>
  );
}